import {HTTP_METHODS} from '@/utils/constants/httpMethods'
import {API_VERSION} from '@/utils/constants/commonConstants'

export const TIER_CONFIG = {
  TIERS: {
    endPoint: 'tiers/tier-setup',
    method: HTTP_METHODS.GET,
  },
  CREATE_UPDATE_TIER: {
    endPoint: 'tiers',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
  },
  TIER_STORES: (tierID, queryParams) => ({
    endPoint: `tiers/${tierID}/stores?limit=50${queryParams}`,
    method: HTTP_METHODS.GET,
  }),
  CREATE_TIER_OPTIONS: {
    endPoint: 'tiers/create-tier-options',
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1,
  },
  MOVE_STORES: tierID => ({
    endPoint: `tiers/${tierID}/move-stores`,
    method: HTTP_METHODS.POST,
  }),
}
